
import {Properties} from '@page/digital-product-ui-mcom/src/js/util/Properties';


async function getProductView(product, viewState) {
  let ProductView;
  if (!product) {
    ProductView = await import(/* webpackChunkName: "TechnicalErrorView" */ '@page/digital-product-ui-mcom/src/js/TechnicalErrorView');
  } else if (product.availability.available === false) {
    ProductView = await import(/* webpackChunkName: "ProductNotAvailableView" */ '@page/digital-product-ui-mcom/src/js/ProductNotAvailableView');
  } else if (product.detail.flags.masterProduct) {
    ProductView = await import(/* webpackChunkName: "MasterProductView" */ '@page/digital-product-ui-mcom/src/js/MasterProductView');
  } else if (product.detail.flags.giftCard) {
    ProductView = await import(/* webpackChunkName: "GiftCardProductView" */ '@page/digital-product-ui-mcom/src/js/GiftCardProductView');
  } else {
    ProductView = await import(/* webpackChunkName: "MemberProductView" */ '@page/digital-product-ui-mcom/src/js/MemberProductView');
  }
  return ProductView;
}


module.exports = {
  getProductView: getProductView
}


// WEBPACK FOOTER //
// /Users/m802941/WebstormProjects/2020/campaigns/shop-the-look-pdp/src/js/views/pdp-loader.js